/**
 * Extracts fields from Volo.ABP `RemoteServiceErrorResponse` JSON
 * (`error.message` / `error.code` / `error.details`) or similar ASP.NET bodies.
 */
export type AbpRemoteServiceErrorFields = {
  message: string | null
  code: string | null
  details: string | null
}

export function tryParseAbpRemoteServiceError(
  responseBodyText: string,
): AbpRemoteServiceErrorFields {
  const empty: AbpRemoteServiceErrorFields = { message: null, code: null, details: null }
  const raw = responseBodyText?.trim()
  if (!raw) return empty
  try {
    const j = JSON.parse(raw) as Record<string, unknown>
    const err = j.error as Record<string, unknown> | undefined
    const message =
      (typeof err?.message === 'string' && err.message.trim()) ||
      (typeof j.message === 'string' && j.message.trim()) ||
      null
    const code = typeof err?.code === 'string' && err.code.trim() ? err.code.trim() : null
    const details =
      typeof err?.details === 'string' && err.details.trim() ? err.details.trim() : null
    return { message, code, details }
  } catch {
    return empty
  }
}

/**
 * Extracts a user-facing message from Volo.ABP `RemoteServiceErrorResponse` JSON
 * (`error.message`, etc.) or similar ASP.NET Core problem bodies.
 */
export function tryParseAbpRemoteServiceMessage(responseBodyText: string): string | null {
  const { message, details } = tryParseAbpRemoteServiceError(responseBodyText)
  return message || details
}
